import { useEffect, useState } from "react";
import Form from "../../../../components/form/Form";
import { useHub, usePreferences } from "../../../../core/Global";
import { toastSuccess } from "../../../../components/base/Toast";
import Icon from "../../../../components/base/Icon";
import TextBox from "../../../../components/form/TextBox";
import PhoneInput from "../../../../components/form/PhoneInput";
import FlexRow from "../../../../components/base/FlexRow";
import DropDown from "../../../../components/form/DropDown";
import Button from "../../../../components/base/Button";
import { v4 as uuidv4 } from 'uuid';
import { API_ROUTES } from "../../../../core/Constants";
import ToggleSwitch from "../../../../components/form/ToggleSwitch";
import ChatForwardRule from "../../../chat/models/ChatForwardRule";




export default function ChatForwardWhatsApp() {


    const hub = useHub();
    const pref = usePreferences();
    const [working, workingSet] = useState<boolean>(false)
    const [forwardAllIncomingChats, forwardAllIncomingChatsSet] = useState<boolean>(false)
    const [forwardAllOutgoingChats, forwardAllOutgoingChatsSet] = useState<boolean>(false)
    const [model, modelSet] = useState<ChatForwardRule[]>([])

    useEffect(() => {
        if (pref?.chatForwardSettingsWhatsApp) {
            forwardAllIncomingChatsSet(pref.chatForwardSettingsWhatsApp.forwardAllIncomingChats);
            forwardAllOutgoingChatsSet(pref.chatForwardSettingsWhatsApp.forwardAllOutgoingChats);
            modelSet(m => pref.chatForwardSettingsWhatsApp.forwardRules);
        }
    }, [pref?.chatForwardSettingsWhatsApp])

    return (
        <Form id="form-chat-forward-wa-rules" className="form"
            onSubmit={(body, callback) => {

                var valid = true;
                var focus = true;

                for (var i = 0; i < model.length; i++) {
                    var m = model[i];

                    if (!m.forwardToNumber || m.forwardToNumber.length < 9) {
                        window.formError(`phone${i}`, "Write a number!", "form-chat-forward-wa-rules", focus);
                        valid = false;
                        focus = false;
                    }

                }

                if (!valid) {
                    return;
                }

                hub.Post("/system/Settings/chatforwardruleswa", {
                    forwardAllIncomingChats,
                    forwardAllOutgoingChats,
                    forwardRules: model
                }, res => {
                    if (res.success) {
                        toastSuccess("Chat forward settings has been updated successfully!");
                    }
                    if (callback) callback(res);
                    workingSet(false);
                });


            }}>
            <div className="card mb-5">
                <div className="card-header border-0">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                            Forward via WhatsApp
                        </h3>
                    </div>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    : <>Update Settings</>
                            }
                        </button>
                    </div>
                </div>
                <div className="card-body border-top px-9 pt-10 pb-10">

                    <ToggleSwitch label="Forward all incoming messages to the defined rules!"
                        name="forwardAllIncomingChatsToWa" raw small className="mb-5"
                        checked={forwardAllIncomingChats}
                        onChange={e => forwardAllIncomingChatsSet(e)} />

                    <ToggleSwitch label="Forward all outgoing messages to the defined rules!"
                        name="forwardAllOutgoingChatsToWa" raw small className="mb-5"
                        checked={forwardAllOutgoingChats}
                        onChange={e => forwardAllOutgoingChatsSet(e)} />

                    <div className="my-10 border-bottom">
                        {/* {JSON.stringify(model)} */}
                    </div>


                    {
                        model.length === 0 &&
                        <div className="text-center my-20">
                            <Button text="Add New Rule" icon="plus" type="outline" className="w-200px"
                                onClick={() => {
                                    modelSet(m => [{
                                        id: uuidv4()
                                    }])
                                }} />
                        </div>
                    }

                    {
                        model.map((item, key) =>
                            <FlexRow key={item.id} alignItems="end" className="mb-4">
                                <div className="w-lg-200px w-xxl-250px me-2">
                                    <PhoneInput key={`txt-phone-wa-${item.id}`} id={`txt-phone-wa-${item.id}`}
                                        name={`phone${key}`} countryCodes="all" block labelUp label="Forward to" noMarginBottom
                                        defaultPhone={item.forwardTo}
                                        onComplete={e => {
                                            modelSet(prevRules =>
                                                prevRules.map(rule =>
                                                    rule.id === item.id
                                                        ? {
                                                            ...rule,
                                                            forwardToNumber: e.phone,
                                                            forwardTo: e
                                                        }
                                                        : rule
                                                ))
                                        }}
                                        onInComplete={() => {
                                            modelSet(prevRules =>
                                                prevRules.map(rule =>
                                                    rule.id === item.id
                                                        ? { ...rule, forwardTo: undefined, forwardToNumber: "" }
                                                        : rule
                                                ))
                                        }}
                                    />
                                </div>
                                <div className="w-lg-200px w-xxl-250px me-2">
                                    <TextBox key={`txt-phone-wa-title-${item.id}`} id={`txt-phone-wa-title-${item.id}`}
                                        name={`title${key}`} placeholder="Description" block labelUp label="&nbsp;" noMarginBottom
                                        value={item.description}
                                        onChange={e => {
                                            modelSet(prevRules =>
                                                prevRules.map(rule =>
                                                    rule.id === item.id
                                                        ? { ...rule, description: e.target.value }
                                                        : rule
                                                ))
                                        }} />
                                </div>
                                <FlexRow className="mb-1">
                                    <button type="button" className="btn btn-light-danger btn-active-light-danger btn-sm btn-icon me-1"
                                        onClick={e => {
                                            e.preventDefault();
                                            modelSet(m => m.filter(f => f.id != item.id))
                                        }}>
                                        <Icon icon="minus" />
                                    </button>
                                    {
                                        model.length - 1 == key &&
                                        <button type="button" className="btn btn-light btn-sm btn-icon"
                                            onClick={e => {
                                                e.preventDefault();
                                                modelSet(m => [...m, {
                                                    id: uuidv4()
                                                }])
                                            }}>
                                            <Icon icon="plus" />
                                        </button>
                                    }
                                </FlexRow>

                            </FlexRow>
                        )
                    }


                </div>
            </div>
        </Form>
    )
}